module.exports = __webpack_public_path__ + "static/img/fish55.57d9551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish55.png
// module id = wOVB
// module chunks = 0